import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnx_confirmation_c4ar';
export const route = 'cnx_confirmation_c4ar/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnx_confirmation_c4ar" */
/* webpackPrefetch: true */
'../components/ConfirmationC4arPage')));